import { useCallback } from "react"
import { useAuth } from "./useAuth"
import {
    fetchCurrentUser,
    updateCurrentUser,
    fetchAllUsers,
    updateUserStatus,
    createUser as createNewUser,
    findUserByEmail,
    changePassword,
} from "../handlers/userHandlers"

/**
 * Custom hook para manejar las operaciones de usuarios
 * @returns {Object} Funciones para interactuar con el servicio de usuarios
 */
export const useUserService = () => {
    const { token, updateUserInfo } = useAuth()

    // Obtener datos del usuario actual
    const getCurrentUser = useCallback(async () => {
        return await fetchCurrentUser(token)
    }, [token])

    // Actualizar datos del usuario actual
    const updateUser = useCallback(
        async (userData) => {
            return await updateCurrentUser(token, userData, updateUserInfo)
        },
        [token, updateUserInfo],
    )

    // Obtener todos los usuarios
    const getAllUsers = useCallback(async () => {
        return await fetchAllUsers(token)
    }, [token])

    // Actualizar estado de un usuario
    const updateStatus = useCallback(
        async (userId, userData) => {
            return await updateUserStatus(token, userId, userData)
        },
        [token],
    )

    // Crear un nuevo usuario
    const createUser = useCallback(
        async (userData) => {
            return await createNewUser(token, userData)
        },
        [token],
    )

    // Cambiar contraseña del usuario
    const changeUserPassword = useCallback(
        async (oldPassword, newPassword) => {
            return await changePassword(token, oldPassword, newPassword)
        },
        [token],
    )

    // Busca usuario por email
    const findUser = useCallback(
        async (email) => {
            return await findUserByEmail(token, email)
        },
        [token],
    )

    return {
        fetchCurrentUser: getCurrentUser,
        updateCurrentUser: updateUser,
        fetchAllUsers: getAllUsers,
        updateUserStatus: updateStatus,
        createUser,
        changePassword: changeUserPassword,
        findUserByEmail: findUser,
    }
}

